import styled from "styled-components";
import { HeartIcon } from "ui";
import { theme } from "ui/themes";

interface HeartProps {
  isHovered: boolean;
  isClicked: boolean;
  isClientTablet?: boolean;
}

interface BoxValueProps {
  margin?: string;
}

interface TagProductProps {
  backgroundColor: string;
}

interface Title1Props {
  existSomeTag?: boolean;
}

const heartColors = ({ isClicked, isHovered }: HeartProps) => {
  if (isClicked) {
    return {
      color: theme.colors.primary["350"],
      secondColor: theme.colors.primary["350"],
    };
  }

  if (isHovered) {
    return {
      color: theme.colors.primary["60"],
    };
  }

  return {
    color: "transparent",
    secondColor: theme.colors.neutral["240"],
  };
};

export const ContainerSkeletonTitle = styled.div<{ maxHeight: string }>`
  max-height: ${({ maxHeight }) => maxHeight ?? "9rem"};
  margin-top: 0;
  overflow: hidden;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: 1rem;
  justify-content: space-between;
`;

export const ContainerSkeletonTagLine = styled.div<{ maxHeight?: string }>`
  max-height: ${({ maxHeight }) => maxHeight ?? "9rem"};
  margin-top: 0;
  overflow: hidden;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: 1rem;
  justify-content: space-between;
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const BoxDesktop = styled.div`
  @media ${theme.device.desktopFirst.tablet} {
    display: none;
  }
`;

export const BoxMobile = styled.div`
  display: none;
  @media ${theme.device.desktopFirst.tablet} {
    display: block;
  }
`;

export const ButtonSkeleton = styled.div`
  max-height: 5rem;
  margin-top: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const ContainerBoxSkeleton = styled.div<{ responsiveOrder?: number }>`
  margin-top: 0;
  margin-left: 2rem;
  overflow: hidden;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media ${theme.device.desktopFirst.tablet} {
    order: ${({ responsiveOrder }) => responsiveOrder ?? 1};
    gap: 1rem;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  /* align-items: center; */
`;

export const SectionBox = styled.section``;

export const HeaderBox = styled.header``;

export const Container = styled.section`
  display: flex;
  position: relative;
  background-color: ${theme.colors.neutral.white};
  border-radius: 2px;
  margin-bottom: 3rem;
  border: thin solid ${theme.colors.neutral["95"]};
  border-radius: 8px;

  ${SectionBox}:first-child {
    flex: 1.4;
    // padding-top:3rem;

    display: flex;
  }

  ${SectionBox}:last-child {
    flex: 0.8;
    padding: 1.65rem 2.5rem 2.5rem 2.5rem;
  }

  @media ${theme.device.desktopFirst.tablet} {
    flex-direction: column;

    ${SectionBox}:first-child {
      flex: 1;
      // padding-top:3rem;
      flex-direction: column;
      display: flex;
    }

    ${SectionBox}:last-child {
      flex: 1;
      padding: 15px;
    }
  }
`;

export const NameMarketplace = styled.h1`
  font-size: 1.2rem;
  font-weight: ${theme.typography.fontWeight.bold};
  margin-left: 0.5rem;
  color: ${theme.colors.neutral["999"]};
`;

export const BoxTags = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 1rem;
  min-height: 2rem;
`;

export const TagProductWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const TagProductPriceOnlySiteContainer = styled.div<TagProductProps>`
  /* display: flex;
  padding: 0.65rem;
  align-items: flex-start;
  gap: 0.875rem;
  margin-top: 0.25rem;
  border-radius: 0.35rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem;
  border-radius: 8px;
  background: ${theme.colors.secondary["250"]};
  max-width: fit-content;
  min-height: 2.875rem;
`;

export const TagProductPriceOnlySiteText = styled.span`
  /* color: ${theme.colors.secondary["250"]}; */
  color: ${theme.colors.neutral.white};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.125rem;
  font-weight: ${theme.typography.fontWeight["500"]};
  line-height: 0.92rem;
  user-select: none;
`;

export const TagIcon = styled.span`
  margin-right: 0.5rem;
  display: flex;
`;

interface TagCampaignBoxProductProps {
  backgroundColor?: string;
  borderColor?: string;
}

export const TagCampaignBoxProduct = styled.section<TagCampaignBoxProductProps>`
  display: flex;
  padding: 0.65rem;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid
    ${({ borderColor }) => borderColor || `${theme.colors.neutral["750"]}`};
  background: ${({ backgroundColor }) =>
    backgroundColor || `${theme.colors.neutral["490"]}`};
`;

export const TagTextCampaignBoxProduct = styled.span`
  color: ${({ color }) => color || theme.colors.neutral.white};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
  font-weight: ${theme.typography.fontWeight["500"]};
  user-select: none;
`;

export const SpanTitle = styled.span`
  font-size: 1.9rem;
  font-weight: ${theme.typography.fontWeight.bold};
`;

export const Title1 = styled.h1<Title1Props>`
  font-size: 2rem;
  margin-bottom: 10px;
  line-height: normal;
  font-weight: ${theme.typography.fontWeight["600"]};
  font-family: ${theme.typography.fontFamily.chivo};
  color: ${theme.colors.neutral["520"]};

  padding-top: ${({ existSomeTag }) => (existSomeTag ? "0px" : "16px")};
`;

export const SubTitle = styled.div`
  font-size: 1rem;
  font-weight: ${theme.typography.fontWeight["400"]};
  font-family: ${theme.typography.fontFamily.chivo};
  color: ${theme.colors.neutral["450"]};
  line-height: normal;
`;

export const FlexBoxCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const Title4 = styled.h4`
  font-size: 14px;
`;

export const BoxValue = styled.div<BoxValueProps>`
  margin: ${({ margin }) => margin};
`;

export const DiscountValue = styled.span`
  font-size: 1.2rem;
  color: ${theme.colors.neutral["400"]};
  margin-right: 0.5rem;
  text-decoration: line-through;
  font-weight: ${theme.typography.fontWeight["600"]};
`;

export const DiscountTag = styled.span`
  font-size: 1.2rem;
  font-weight: ${theme.typography.fontWeight["600"]};
  color: ${theme.colors.secondary["300"]};
`;

export const ValueDesc = styled.h1`
  font-size: 3rem;
  margin-bottom: 10px;
  margin-top: 1rem;
  line-height: 35px;
  font-weight: 700;
  color: ${theme.colors.primary["200"]};
`;

export const DescriptionParcels = styled.p`
  font-size: 1.4rem;
  color: ${theme.colors.neutral["999"]};
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

export const FavoriteContainer = styled.div`
  border-radius: 100px;
  width: 3rem;
  height: 3rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${theme.colors.neutral["white-075"]};
  right: 0;

  @media ${theme.device.desktopFirst.tablet} {
    width: 32px;
    height: 32px;
    background-color: ${theme.colors.neutral.white};
    top: ${theme.space.x2};
    right: ${theme.space.x2};
    z-index: 1;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    top: ${theme.space.x4};
    right: ${theme.space.x4};
  }
`;

export const Heart = styled(HeartIcon).attrs<HeartProps>(
  ({ isHovered, isClicked }) => ({
    ...heartColors({ isClicked, isHovered }),
    height: 28,
    width: 28,
  })
)<HeartProps>`
  animation: ${({ isClicked }) => (isClicked ? "0.5s ease-in-out" : "none")};
`;
